var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNigeriaflag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3286",
    "data-name": "Group 3286",
    transform: "translate(-1660 -65)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1015",
    "data-name": "Rectangle 1015",
    d: "M3,0H7A0,0,0,0,1,7,0V16a0,0,0,0,1,0,0H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0Z",
    transform: "translate(1660 65)",
    fill: "#008751"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1017",
    "data-name": "Rectangle 1017",
    width: 7,
    height: 16,
    transform: "translate(1667 65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1016",
    "data-name": "Rectangle 1016",
    d: "M0,0H4A3,3,0,0,1,7,3V13a3,3,0,0,1-3,3H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(1674 65)",
    fill: "#008751"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNigeriaflag);
export default __webpack_public_path__ + "static/media/nigeriaflag.94aaec9eac442335dac735b5c64e0619.svg";
export { ForwardRef as ReactComponent };